export default __webpack_public_path__ + "static/blog_cover_default-870cafa2502353c3d96deba5ecc6c010.png";